import React from 'react';
import DataSet from '@antv/data-set';
import { Chart, Geom, Axis, Tooltip, Legend } from 'bizcharts';

const RevenueByDateLineChart = ({ data, mediums }) => {
  const colors = {};
  mediums.forEach((m) => {
    colors[m.medium] = m.color;
  });

  const transformedData = data.map((day) => {
    const transformedDay = { date: day.date };
    mediums.forEach((source) => {
      if (day[source.medium]) {
        transformedDay[source.medium] = day[source.medium].revenue;
      } else {
        transformedDay[source.medium] = 0;
      }
    });
    return transformedDay;
  });

  const dv = new DataSet.View().source(transformedData);
  dv.transform({
    type: 'fold',
    fields: mediums.map((m) => m.medium),
    key: 'source',
    value: 'revenue',
  });

  const scale = {
    revenue: {
      min: 0,
      alias: 'Revenue',
    },
    date: {
      range: [0, 1],
    },
  };

  return (
    <Chart height={400} data={dv} scale={scale} forceFit>
      <Legend />
      <Axis name="date" />
      <Axis name="revenue" />
      <Tooltip crosshairs={{ type: 'y' }} />
      <Geom
        type="line"
        position="date*revenue"
        size={0}
        color={[
          'source',
          (channel) => (channel === 'total' ? '#FF0000' : colors[channel] || '#000000'),
        ]}
      />
      <Geom
        type="point"
        position="date*revenue"
        size={data.length > 400 ? 1.7 : 3}
        shape={'circle'}
        color={[
          'source',
          (channel) => (channel === 'total' ? '#FF0000' : colors[channel] || '#000000'),
        ]}
        style={{ stroke: '#fff', lineWidth: 1 }}
      />
    </Chart>
  );
};

export default RevenueByDateLineChart;
